<template>
  <div id="notice">
    <div class="inner_static">
      <ul class="lst_notice">
        <li v-for="(item,index) in dispList" :key="index">
          <a @click="toDetailClick(index)">
            <span class="date">{{formatDay(item.day)}}</span><strong class="tit">{{item.title}}</strong>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import * as App from '../../../utils/App'
import {KG_STORAGE_KEY} from '../../../constants/App'

export default {
  data () {
    return {
      newsList: []
    }
  },
  props: {
    upperLimit: {
      type: Number,
      default: -1
    }
  },
  methods: {
    init: function () {
      this.newsList[0] = {day: '20201211', title: 'オーダー家具設計支援システムの日本特許取得　（特許3079206号）', text: 'テスト本文１'}
      this.newsList[1] = {day: '20201102', title: '一般週間誌　『週間ダイヤモンド』　に弊社事業が取材されました', text: 'テスト本文２'}
      this.newsList[2] = {day: '20200123', title: 'アトムリビンテック株式会社とのウェブFurnitureMaker『デマンドメーカー』業務提携', text: 'テスト本文３'}
      this.newsList[3] = {day: '20200104', title: 'ゴールデンウィーク期間（平成29年4月29日(土)～ 5月7日(日)は休業させていただきます。', text: 'テスト本文４'}
      this.newsList[4] = {day: '20200105', title: 'テストタイトル5', text: 'テスト本文５'}
      this.newsList[5] = {day: '20200106', title: 'テストタイトル6', text: 'テスト本文６'}
      this.newsList[6] = {day: '20200107', title: 'テストタイトル7', text: 'テスト本文７'}
      this.newsList[7] = {day: '20200108', title: 'テストタイトル8', text: 'テスト本文８'}
      this.newsList[8] = {day: '20200109', title: 'テストタイトル9', text: 'テスト本文９'}
      this.newsList[9] = {day: '20200110', title: 'テストタイトル10', text: 'テスト本文１０'}
      this.newsList[10] = {day: '20200111', title: 'テストタイトル11', text: 'テスト本文１１'}
      this.newsList[11] = {day: '20200112', title: 'テストタイトル12', text: 'テスト本文１２'}
      this.newsList[12] = {day: '20200113', title: 'テストタイトル13', text: 'テスト本文１３'}
      this.newsList[13] = {day: '20200114', title: 'テストタイトル14', text: 'テスト本文１４'}
      this.newsList[14] = {day: '20200115', title: 'テストタイトル15', text: 'テスト本文１５'}
      this.newsList[15] = {day: '20200116', title: 'テストタイトル16', text: 'テスト本文１６'}
      this.newsList[16] = {day: '20200117', title: 'テストタイトル17', text: 'テスト本文１７'}
      this.newsList[17] = {day: '20200118', title: 'テストタイトル18', text: 'テスト本文１８'}
      this.newsList[18] = {day: '20200119', title: 'テストタイトル19', text: 'テスト本文１９'}
      this.newsList[19] = {day: '20200120', title: 'テストタイトル20', text: 'テスト本文２０'}
    },
    toDetailClick: function (index) {
      // 一覧クリック時に詳細画面に遷移
      App.setLocalStorage(KG_STORAGE_KEY.SELECT_NEWS_DATA, this.newsList[index])
      this.$router.push('/kagull/news/detail')
    },
    formatDay: function (dayStr) {
      if (!dayStr) return ''
      let temp = dayStr.split('')
      let ret = ''
      for (let i = 0; i < temp.length; i++) {
        if (i > 3 && i % 2 === 0) {
          if (temp[i] === '0') {
            ret += '.'
          } else {
            ret += ('.' + temp[i])
          }
        } else {
          ret += temp[i]
        }
      }
      return ret
    },
    newsListLength: function () {
      return this.newsList.length
    }
  },
  computed: {
    dispList: function () {
      if (this.upperLimit < 0) {
        return this.newsList
      } else {
        return this.newsList.slice(0, this.upperLimit)
      }
    }
  },
  created: function () {
    this.init()
  }
}
</script>
<style src="../../css/style.scss" lang="scss" scoped></style>
<style src="../../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/components/top/NewsList.vue